import styles from './header.module.scss';

function Header() {
  return (
    <div className={styles.header}>
      <img src="images/logo_urbanease_horizontal.svg" alt="logo" />
    </div>
  );
}

export default Header;
